import generalForm from "./index.vue"

generalForm.install = Vue => Vue.component(generalForm.name, generalForm); //注册组件

export default generalForm;